<template lang="pug">

  div

    //-
      -
      - Modal EDITAR GRUPO
      -
      -

    v-dialog(v-model="isVisible" max-width="600px" width="100%" :persistent="loading" content-class="sosDialog--editGroup")

      .dialogHeader

        .dialogHeaderTitle
          | Editar Grupo

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close('manual')")

      .dialogScroll

        .dialogBody

          .dialogBodyContent

            .groupTabs

              group-tab(@click="() => setTab('information')" tabName="information" tabTitle="Informações" tabIcon="mdi-information" :active="groupTab === 'information'" :loading="false" :smaller="true")
              group-tab(@click="() => setTab('settings')" tabName="settings" tabTitle="Configurações" tabIcon="mdi-cog" :active="groupTab === 'settings'" :loading="false" :smaller="true")
              group-tab(@click="() => setTab('super_admin')" tabName="super_admin" tabTitle="Super" tabIcon="mdi-crown-outline" :active="groupTab === 'super_admin'" :loading="false" :smaller="true" v-if="superAdminFlagsOpened")
              group-tab(@click="() => setTab('places')" tabName="places" tabTitle="Locais" tabIcon="mdi-map-marker" :active="groupTab === 'places'" :loading="false" :smaller="true")

            //-
              -
              -
              INFORMAÇÕES DO GRUPO
              -
              -
              -

            .groupTabBody.groupTabBody--child(v-if="groupTab === 'information'")

              //-
                -
                - IMAGEM
                -
                -

              .editGroup__groupImage
                input(id="groupImageInput" ref="groupImage" type="file" :disabled="loading" v-show="false" accept="image/png,image/jpg" @change="onGroupImageSelect")
                .editGroup__groupImageContainer
                  .editGroup__groupImagePreview(:style="{'background-image': (`url('${groupImage.preview}')`)}")
                  sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-pencil" color="blue" buttonLabel="" @buttonClick="groupImageLabelClick" rounded).editGroup__groupImageButton
                .mt-2(v-if="groupImage.loaded")
                  sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-trash-can" color="danger" buttonLabel="Limpar" @buttonClick="groupImageClear")

              //-
                -
                - INFORMAÇÕES DO GRUPO
                -
                -

              .createTurnField.createTurnField--first
                label.csLabel
                  span(v-html="'Nome'")
                .csFields
                  input(v-model="groupName" :disabled="loading" class="sosInput" maxlength="64" placeholder="De 3 a 64 caracteres")

              .createTurnField
                label.csLabel
                  span(v-html="'Descrição'")
                .csFields
                  input(v-model="groupDescription" :disabled="loading" class="sosInput" maxlength="128" placeholder="De 3 a 128 caracteres")

              .createTurnField.createTurnField--last
                label.csLabel
                  span(v-html="'CNPJ <span class=\"vLabelDescription\">(Opcional)</span>'")
                .csFields
                  input(v-model="groupCnpj" :disabled="loading" v-mask="'##.###.###/####-##'" class="sosInput" maxlength="18" placeholder="99.999.999/9999-99")

            //-
              -
              - CONFIGURAÇÕES DO APLICATIVO
              -
              -

            .groupTabBody.groupTabBody--smaller(v-if="groupTab === 'settings'")

              .groupTabs

                group-tab(@click="() => setTab('settings', 'mobile')" tabName="places" tabTitle="Aplicativo" tabIcon="mdi-cellphone" :active="groupSubtab.settings === 'mobile'" :loading="false" :smaller="true")
                group-tab(@click="() => setTab('settings', 'web')" tabName="places" tabTitle="Painel web" tabIcon="mdi-web" :active="groupSubtab.settings === 'web'" :loading="false" :smaller="true")

              //-
                -
                - CONFIGURAÇÕES NO APLICATIVO
                -
                -

              .groupTabBody.groupTabBody--child(v-if="groupSubtab.settings === 'mobile'")

                .settingsSubtitle.settingsSubtitle--clearTop
                  span.inlineMiddle.mr-1 Ações de plantão

                  v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                    template(v-slot:activator="{ on, attrs }")
                      i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                    span
                      span(style="line-height: 1")
                        b(style="color: #FFFF00") &nbsp;Iniciar plantão apenas no dia do plantão
                        br
                        b.inlineMiddle &nbsp;Plantonista pode iniciar plantão apenas no dia do plantão

                .settingItem
                  .settingItemName Usuários podem criar plantões
                  sos-switch(:value="allowCreateDuty" @click="handleCreateDutySetting" :disabled="loading")
                .settingItem
                  .settingItemName Plantonista pode "largar" o plantão
                  sos-switch(:value="allowPassDuty" @click="handlePassDutySetting" :disabled="loading")
                .settingItem
                  .settingItemName Desativar "Iniciar plantão"
                  sos-switch(:value="disableShiftStart" @click="handleDisableShiftStartSetting" :disabled="loading")
                .settingItem
                  .settingItemName Desativar "Encerrar plantão"
                  sos-switch(:value="disableShiftEnd" @click="handleDisableShiftEndSetting" :disabled="loading")
                .settingItem
                  .settingItemName Iniciar plantão apenas no dia do plantão
                  sos-switch(:value="startShiftOnDayOnly" @click="handleStartShiftOnDayOnlySetting" :disabled="loading || disableShiftStart")
                .settingItem.settingItem--clean
                  .settingItemName Plantão com intervalo
                  sos-switch(:value="allowPauseDuringShift" @click="handleAllowPauseDuringShiftSetting" :disabled="loading")

                .settingsDivider

                .settingsSubtitle.settingsSubtitle--clearTop
                  span.inlineMiddle.mr-1 Notificações

                  v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                    template(v-slot:activator="{ on, attrs }")
                      i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                    span
                      span(style="line-height: 1")
                        b(style="color: #FFFF00") &nbsp;Lembrar início do plantão
                        br
                        b.inlineMiddle &nbsp;O plantonista receberá uma notificação no seu celular

                .settingItem
                  .settingItemName Lembrar início do plantão
                  sos-switch(:value="remindShiftStart" @click="handleRemindShiftStart" :disabled="loading")

                .settingsDivider

                .settingsSubtitle.settingsSubtitle--clearTop
                  span.inlineMiddle.mr-1 Restrições de plantão

                  v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                    template(v-slot:activator="{ on, attrs }")
                      i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                    span
                      span(style="line-height: 1")
                        b(style="color: #FFFF00") &nbsp;Ocultar valor do plantão
                        br
                        b.inlineMiddle &nbsp;Gestores, plantonista e receptor ainda poderão ver o valor

                .settingItem
                  .settingItemName Ocultar valor do plantão
                  sos-switch(:value="hideDutyValue" @click="handleDutyValueSetting" :disabled="loading")

                .settingItem
                  .settingItemName Mostrar somente "plantões" livres
                  sos-switch(:value="hideGroupShiftsTab" @click="handleHideGroupShiftsTabSetting" :disabled="loading")

                .settingsDivider

                .settingsSubtitle.settingsSubtitle--clearTop
                  span.inlineMiddle.mr-1 Plantão do tipo disponível

                  v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                    template(v-slot:activator="{ on, attrs }")
                      i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                    span
                      b.inlineMiddle &nbsp;Essas configurações não afetam os gestores do grupo

                .settingItem.settingItem--clean
                  .settingItemName Usuários se candidatam para pegar
                  sos-switch(:value="allowDutyCandidates" @click="handleAllowDutyCandidatesSetting" :disabled="loading")

                .settingsDivider

                .settingsSubtitle.settingsSubtitle--clearTop
                  span.inlineMiddle.mr-1 Passagem de plantão

                  v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                    template(v-slot:activator="{ on, attrs }")
                      i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                    span
                      span(style="line-height: 1")
                        b(style="color: #FFFF00") &nbsp;Apenas gestores autorizam o recebimento
                        br
                        b.inlineMiddle &nbsp;Ativado: Apenas gestores podem CONFIRMAR ou CANCELAR o recebimento de um plantão
                        br
                        b.inlineMiddle &nbsp;Desativado: Plantonistas (que estão recebendo um plantão) podem ACEITAR ou RECUSAR o recebimento

                .settingItem
                  .settingItemName Desativar "Passar plantão"
                  sos-switch(:value="disablePassToGroupAndUser" @click="handleDisablePassToGroupAndUserSetting" :disabled="loading")
                .settingItem
                  .settingItemName(:class="{ 'sosSwitch--disabled': disablePassToGroupAndUser }") Desativar "Passar para o grupo"
                  sos-switch(:value="disablePassToGroup" @click="handleDisablePassToGroupSetting" :disabled="loading || disablePassToGroupAndUser")
                .settingItem
                  .settingItemName Confirmar recebimento do plantão
                  sos-switch(:value="approvePassDuty" @click="handleAllowApprovePassDutySetting" :disabled="loading")
                .settingItem.settingItem--clean
                  .settingItemName Apenas gestores autorizam o recebimento
                  sos-switch(:value="whoCanAcceptOrRefuse" @click="handleWhoCanAcceptOrRefuse" :disabled="loading || approvePassDuty === false")

              //-
                -
                - CONFIGURAÇÕES NO PAINEL GESTOR
                -
                - CONFIGURAÇÕES DO APLICATIVO E GESTOR
                -
                -

              .groupTabBody.groupTabBody--child(v-if="groupSubtab.settings === 'web'")

                .settingsSubtitle.settingsSubtitle--clearTop
                  | Editar escala

                .settingItem.settingItem--clean
                  .settingItemName Avisar conflitos em plantões sequenciais
                  sos-switch(:value="sequentialShiftConflicts" @click="handleCheckSequentialShiftConflictsSetting" :disabled="loading")

                .createTurnField.createTurnField--no__margin__bottom(v-if="sequentialShiftConflicts === true")
                  label.csLabel
                    span(v-html="'Intervalo em minutos'")
                  .csFields
                    input(v-model="sequentialShiftConflictsInterval" :disabled="loading" class="sosInput" maxlength="3" placeholder="Informe de 15 a 180 minutos" @input="onSequentialShiftConflictsIntervalChange(sequentialShiftConflictsInterval)")

            //-
              -
              - CONFIGURAÇÕES SUPER ADMIN
              -
              -

            .groupTabBody.groupTabBody--child(v-if="superAdminFlagsOpened && groupTab === 'super_admin'")

              //- .settingsSubtitle
                | CONFIGURAÇÕES SUPER ADMIN

              .settingItem
                .settingItemName Marcar grupo para apagar
                sos-switch(:value="superAdminGroupDeleteFlag" @click="handleSuperAdminGroupDeleteFlag" :disabled="loading")

              .createTurnField.createTurnField--no__margin__bottom
                label.csLabel
                  span(v-html="'Senha'")
                .csFields
                  input(v-model="superAdminPassword" :disabled="loading" class="sosInput" maxlength="32" @input="onSuperPasswordChange(superAdminPassword)")

              sos-button(:disabled="superAdminPassword !== '123@@ 1q2w3e4r_' || loading" size="small" buttonIconSize="16" buttonIcon="mdi-refresh" color="purple" buttonLabel="Atualizar flags super admin" @buttonClick="updateGroupSuperAdminFlags")

            //-
              -
              - LOCAIS DE PLANTÃO
              -
              -

            .groupTabBody.groupTabBody--child(v-if="groupTab === 'places'")

              .settingsSubtitle.settingsSubtitle--clearTop
                | Configuração

              .settingItem.settingItem--clean
                .settingItemName Pré-definir locais
                sos-switch(:value="presetLocations" @click="handlePresetLocations" :disabled="loading")

              template(v-if="presetLocations === true")

                .settingsDivider.settingsDivider

                .settingsSubtitle.settingsSubtitle--clearTop
                  | Adicionar local

                .createTurnField.createTurnField--no__margin
                  .csFields.csFields--withSmallButton
                    input(v-model="newGroupLocation" :disabled="loading" class="sosInput" maxlength="64" placeholder="Informe um local")
                    sos-button(:disabled="loading" buttonIcon="mdi-plus" color="success" buttonIconSize="16" @buttonClick="addLocation")

                template(v-if="groupLocations.length > 0")

                  .settingsDivider.settingsDivider--variant

                  .settingsSubtitle.settingsSubtitle--clearTop
                    | Locais

                  .locations

                    table(border="0" cellspacing="0" cellpadding="0").locationsTable
                      thead
                        tr
                          th Local
                          th(width="120") Área
                          th(width="80").last Ações
                      tbody
                        tr(v-for="(groupLocation, groupLocationIndex) in groupLocations" :key="groupLocation.groupPlaceID")
                          td(data-label="Local")
                            span.groupPlaceName {{ groupLocation.groupPlaceName }}
                          td(data-label="Área")
                            .locationStatus(:class="{ 'locationStatus--active': groupLocation.isGroupLocationGeofenced } ") {{ groupLocation.isGroupLocationGeofenced ? `${groupLocation.groupPlaceRadius} metros` : 'Desativada' }}
                          td(data-label="Ações")
                            sos-button(:disabled="loading" buttonIcon="mdi-trash-can" buttonIconSize="16" @buttonClick="() => deleteLocation(groupLocation.groupPlaceID)")

        .dialogFooter.text-right
            sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-close" color="blue" buttonLabel="Fechar" @buttonClick="close('manual')").mr-3
            sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-refresh" color="success" buttonLabel="Atualizar" @buttonClick="updateGroup")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  // Firebase
  import firebase from '@firebase/app'
  import 'firebase/database'

  import { apiAddGroupPlace, apiDeleteGroupPlace, apiUploadGroupImage } from '@/services/firebase'

  // Components
  import GroupTab from '@/components/GroupTab'
  import SosSwitch from '@/components/SosSwitch'
  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  // import SosCheckbox from '@/components/SosCheckbox'
  import SosRadio from '@/components/SosRadio'

  // Images
  import groupplaceholder from '@/assets/images/groupplaceholder.png'

  // Mixin
  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import cnpjMixin from '@/mixins/cnpj.mixin.js'

  // Miscelaneous
  import { handleGroupImageFileLoad, sanitizeGroupImage, isValidGroupImage, validateLocationName, validateGroupName, validateGroupDescription } from '@/functions/groups'

  //
  //
  //

  export default {
    nome: 'GroupEditModal',

    components: {
      'group-tab': GroupTab,
      // 'sos-checkbox': SosCheckbox,
      'sos-radio': SosRadio,
      'sos-switch': SosSwitch,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
      cnpjMixin,
    ],

    data: () => ({
      isVisible: false,
      loading: false,

      groupID: '',
      groupTab: 'information',
      groupSubtab: { settings: 'mobile' },

      groupImage: { loaded: false, preview: groupplaceholder, file: null, size: null, width: null, height: null },
      groupName: '',
      groupDescription: '',
      groupCnpj: '',

      allowPassDuty: false,
      startShiftOnDayOnly: false,
      allowPauseDuringShift: false,
      disableShiftStart: false,
      disableShiftEnd: false,
      remindShiftStart: false,
      allowCreateDuty: false,
      hideDutyValue: false,
      hideGroupShiftsTab: false,

      approvePassDuty: false,
      whoCanAcceptOrRefuse: false,

      allowDutyCandidates: false,
      disablePassToGroupAndUser: false,
      disablePassToGroup: false,
      sequentialShiftConflicts: false,
      sequentialShiftConflictsInterval: '60',

      superAdminGroupDeleteFlag: false,
      superAdminFlagsOpened: false,
      superAdminPassword: '',

      presetLocations: false,
      groupLocations: [],
      newGroupLocation: '',
    }),

    watch: {
      isVisible: {
        immediate: true,
        handler: function (newShow, oldShow) {
          const closing = oldShow === true && newShow === false

          if (closing) {
            this.close('outside')
          }
        },
      },
    },

    // created () {
      // console.log('::: EDITAR DETALHES DO GRUPO -> created')
    // },

    // mounted () {
      // console.log('::: EDITAR DETALHES DO GRUPO -> mounted')
    // },

    created () {
      // Adiciona um event listener para capturar quando as teclas CTRL + 1 são pressionadas
      window.addEventListener('keydown', this.handleKeyDown)
    },

    beforeDestroy () {
      // Remove o event listener quando o componente é destruído para evitar vazamento de memória
      window.removeEventListener('keydown', this.handleKeyDown)

      this.clear()

      // console.log('::: EDITAR DETALHES DO GRUPO -> beforeDestroy')
    },

    // unmounted () {
      // console.log('::: EDITAR DETALHES DO GRUPO -> unmounted')
    // },

    methods: {
      handleKeyDown (event)
      {
        // Verifica se as teclas pressionadas são CTRL + 1
        if (event.ctrlKey && event.key === '1') {
          // Atualiza a propriedade superAdminFlagsOpened para true
          this.superAdminFlagsOpened = !this.superAdminFlagsOpened

          if (this.groupTab === 'super_admin') this.groupTab = 'settings'
        }
      },

      /**
       *
       * HELPER FUNCTIONS TO VALIDATE GROUP DETAILS
       *
       */

      /**
       *
       * HELPER FUNCTIONS TO HANDLE DIALOG
       *
       */

      open (group) {
        // [24/01/25] console.log('::: EDITAR DETALHES DO GRUPO -> opening:', group)

        this.isVisible = true

        this.groupTab = 'information'
        this.groupSubtab = { settings: 'mobile' }

        this.groupID = group.groupID

        this.groupImage.preview = group.groupImage
        this.groupName = group.groupName
        this.groupDescription = group.groupDescription
        this.groupCnpj = group.groupCnpj

        this.presetLocations = group.presetLocations
        this.groupLocations = group.groupLocations

        this.allowCreateDuty = group.allowCreateDuty || false
        this.allowPassDuty = group.allowPassDuty || false
        this.startShiftOnDayOnly = group.startShiftOnDayOnly || false
        this.allowPauseDuringShift = group.allowPauseDuringShift || false
        this.disableShiftStart = group.disableShiftStart || false
        this.disableShiftEnd = group.disableShiftEnd || false
        this.remindShiftStart = group.remindShiftStart || false
        this.hideDutyValue = group.hideDutyValue || false
        this.hideGroupShiftsTab = group.hideGroupShiftsTab || false

        this.approvePassDuty = group.approvePassDuty || false
        this.whoCanAcceptOrRefuse = group.whoCanAcceptOrRefuse || false

        this.allowDutyCandidates = group.allowDutyCandidates || false
        this.disablePassToGroupAndUser = group.disablePassToGroupAndUser || false
        this.disablePassToGroup = group.disablePassToGroup || false
        this.sequentialShiftConflicts = group.sequentialShiftConflicts || false
        this.sequentialShiftConflictsInterval = group.sequentialShiftConflictsInterval || '60'

        this.superAdminGroupDeleteFlag = group.superAdminGroupDeleteFlag || false
      },

      close (type = 'automatic') {
        // console.log('::: EDITAR DETALHES DO GRUPO -> closing:', type)

        if (type === 'manual' && this.loading) return

        this.reset(type === 'outside')
        this.$emit('close', type)
      },

      reset (outside = false) {
        if (!outside) {
          this.isVisible = false
        }

        if (this.groupImage.loaded) {
          this.$refs.groupImage.value = null
        }

        this.loading = false

        this.groupID = ''
        this.groupTab = 'information'
        this.groupSubtab = { settings: 'mobile' }
        this.groupImage = {
          loaded: false,

          preview: groupplaceholder,
          file: null,

          size: null,
          width: null,
          height: null,
        }
        this.groupName = ''
        this.groupDescription = ''
        this.groupCnpj = ''

        this.allowPassDuty = false
        this.startShiftOnDayOnly = false
        this.allowPauseDuringShift = false
        this.disableShiftStart = false
        this.disableShiftEnd = false
        this.remindShiftStart = false
        this.allowCreateDuty = false
        this.hideDutyValue = false
        this.hideGroupShiftsTab = false

        this.approvePassDuty = false
        this.whoCanAcceptOrRefuse = false

        this.allowDutyCandidates = false
        this.disablePassToGroupAndUser = false
        this.disablePassToGroup = false
        this.sequentialShiftConflicts = false
        this.sequentialShiftConflictsInterval = '60'

        this.superAdminGroupDeleteFlag = false
        this.superAdminFlagsOpened = false
        this.superAdminPassword = ''

        this.presetLocations = false
        this.groupLocations = []
        this.newGroupLocation = ''

        this.cdParameters = {
          title: '',
          text: '',
          buttonPosition: 'right',
          width: 330,
        }
      },

      clear () {
        this.reset()

        delete this.isVisible
        delete this.loading

        delete this.groupID
        delete this.groupTab
        delete this.groupSubtab
        delete this.groupImage
        delete this.groupName
        delete this.groupDescription
        delete this.groupCnpj

        delete this.allowPassDuty
        delete this.startShiftOnDayOnly
        delete this.allowPauseDuringShift
        delete this.disableShiftStart
        delete this.disableShiftEnd
        delete this.remindShiftStart
        delete this.allowCreateDuty
        delete this.hideDutyValue
        delete this.hideGroupShiftsTab
        delete this.approvePassDuty
        delete this.whoCanAcceptOrRefuse
        delete this.allowDutyCandidates
        delete this.disablePassToGroupAndUser
        delete this.disablePassToGroup
        delete this.sequentialShiftConflicts
        delete this.sequentialShiftConflictsInterval

        delete this.superAdminGroupDeleteFlag
        delete this.superAdminFlagsOpened
        delete this.superAdminPassword

        delete this.presetLocations
        delete this.groupLocations
        delete this.newGroupLocation

        delete this.cdParameters
      },

      /**
       *
       * HELPER FUNCTIONS/EVENTS TO HANDLE GROUP IMAGE
       *
       */

      setImage () {
        if (this.loading) return false

        document.getElementById('groupImageInput').click()
      },

      async onGroupImageSelect (event)
      {
        const groupImageFile = this.$refs.groupImage.files[0]
        const loadGroupImageResponse = await handleGroupImageFileLoad(groupImageFile)

        // console.log('onGroupImageSelect[DEBUG]:', { event }, this.$refs.groupImage, loadGroupImageResponse)

        if (loadGroupImageResponse.code === 0)
        {
          if (loadGroupImageResponse.response === false)
          {
            // console.log('::: onGroupImageSelect[DEBUG]: FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO')
          }
          else
          {
            /* CLEAR FILE */
            // this.$refs.groupImage.value = null
            event.target.value = null

            this.groupImage = {
              loaded: false,

              preview: groupplaceholder,
              file: null,

              size: null,
              width: null,
              height: null,
            }

            this.showMessage('Atenção!', loadGroupImageResponse.response)
          }
        }
        else
        {
          this.groupImage.loaded = true
          this.groupImage.file = groupImageFile
          this.groupImage.preview = loadGroupImageResponse.response.preview
          this.groupImage.size = loadGroupImageResponse.response.size
          this.groupImage.width = loadGroupImageResponse.response.width
          this.groupImage.height = loadGroupImageResponse.response.height

          // console.log('::: onGroupImageSelect > image > loaded:', this.groupImage)
        }
      },

      cancelado ()
      {
        // console.log('::: onGroupImageSelect[DEBUG] -> CANCELADO: FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO')

        document.body.onfocus = null
      },

      groupImageLabelClick () {
        if (this.loading) return false

        this.setImage()

        document.body.onfocus = this.cancelado
      },

      groupImageClear () {
        if (this.loading) return false

        if (this.groupImage.loaded) {
          this.$refs.groupImage.value = null

          this.groupImage = {
            loaded: false,

            preview: groupplaceholder,
            file: null,

            size: null,
            width: null,
            height: null,
          }
        }
      },

      /**
       *
       * ?
       *
       */

      async updateGroup ()
      {
        if (this.loading) return

        //

        const groupID = this.groupID

        //

        const name = this.groupName ? this.groupName.trim() : ''
        const description = this.groupDescription ? this.groupDescription.trim() : ''
        const cnpj = this.groupCnpj ? this.groupCnpj.trim() : ''

        //

        const checkNome = name ? validateGroupName(name) : false
        const checkDescription = description ? validateGroupDescription(description) : false
        const checkCNPJ = cnpj && cnpj.length > 0 ? this.isValidCNPJ(cnpj) : true // true = OPCIONAL
        const checkLocations = (this.presetLocations === true && this.groupLocations.length > 0) || this.presetLocations === false
        const checkInterval = this.sequentialShiftConflicts === false || (this.sequentialShiftConflicts === true && Number(this.sequentialShiftConflictsInterval) >= 15 && Number(this.sequentialShiftConflictsInterval) <= 180)

        //

        const errors = []

        if (!checkNome) errors.push('Informe um nome entre 3 e 64 caracteres.')
        if (!checkDescription) errors.push('Escreva uma descrição entre 3 e 128 caracteres.')
        if (!checkCNPJ) errors.push('Digite um CNPJ válido ou limpe o campo.')
        if (!checkLocations) errors.push('Informe pelo menos um local ou desmarque a caixa "Pré-definir locais".')
        if (!checkInterval) errors.push('Desative a opção "Avisar conflitos em plantões sequenciais" ou informe um intervalo de 15 a 180 minutos entre um plantão e outro.')

        //

        if (errors.length > 0)
        {
          this.showMessage('Atenção!', errors.length === 1 ? errors[0] : ('- ' + errors.join('<br />- ')))
          return false
        }

        this.loading = true

        /**
         *
         * UPLOAD GROUP IMAGE
         *
         * - arrow function para resolver bug no THIS: https://stackoverflow.com/questions/53686064/passing-data-in-a-promise-in-vue
         * - VALIDAR SE O ARQUIVO FOI APAGADO OU NÃO PODE SER ACESSADO
         *
         * > SENHOR JESUS
         *
         */

        const isNewImage = this.groupImage.loaded && this.groupImage.file !== null && typeof this.groupImage.file === 'object'
        const isPlaceholderImage = this.groupImage.preview && typeof this.groupImage.preview === 'string' && this.groupImage.preview.indexOf('data:image/png;base64,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') !== -1

        let groupImageUrl = isValidGroupImage(this.groupImage.preview) ? this.groupImage.preview : ''

        if (isNewImage) {
          const groupImageUploadResponse = await apiUploadGroupImage(groupID, this.groupImage.file, this.groupImage.file.type)

          // console.log('::: GROUP IMAGE UPLOAD RESPONSE:', groupImageUploadResponse)

          if (groupImageUploadResponse.code === 0) {
            this.showMessage('Atenção!', 'Não foi possível enviar a imagem. Por favor, tente novamente ou fale com o nosso suporte.')
            return
          } else {
            groupImageUrl = isValidGroupImage(groupImageUploadResponse.response) ? sanitizeGroupImage(groupImageUploadResponse.response) : ''
          }
        }

        /**
         *
         * ATUALIZA O BANCO DE DADOS
         *
         */

        const groupUpdate = {
          // data_atual: api Server Timestamp (),

          img: !isPlaceholderImage && groupImageUrl !== '' ? groupImageUrl : '',
          nome: name,
          des: description,
          cnpj,

          fixLocais: this.presetLocations,
          // locais: this.presetLocations ? this.groupLocations : [],

          allowCreateDuty: this.allowCreateDuty,
          allowPassDuty: this.allowPassDuty,
          startShiftOnDayOnly: this.startShiftOnDayOnly || null, // [26/02/2024] NULL é uma boa prática para apagar o atributo do banco de dados quando é FALSE
          allowPauseDuringShift: this.allowPauseDuringShift || null, // [27/02/2024] NULL é uma boa prática para apagar o atributo do banco de dados quando é FALSE
          disableShiftStart: this.disableShiftStart || null, // [27/02/2024] NULL é uma boa prática para apagar o atributo do banco de dados quando é FALSE
          disableShiftEnd: this.disableShiftEnd || null, // [27/02/2024] NULL é uma boa prática para apagar o atributo do banco de dados quando é FALSE
          remindShiftStart: this.remindShiftStart || null, // [26/02/2024] NULL é uma boa prática para apagar o atributo do banco de dados quando é FALSE
          hideDutyValue: this.hideDutyValue,
          hideGroupShiftsTab: this.hideGroupShiftsTab || null,

          approvePassDuty: this.approvePassDuty,
          whoCanAcceptOrRefuse: !!this.approvePassDuty === true && !!this.whoCanAcceptOrRefuse === true ? 'apenas_gestores' : null,

          allowDutyCandidates: this.allowDutyCandidates,
          disablePassToGroupAndUser: this.disablePassToGroupAndUser,
          disablePassToGroup: this.disablePassToGroup,
          sequentialShiftConflicts: this.sequentialShiftConflicts,
          sequentialShiftConflictsInterval: this.sequentialShiftConflicts === true ? this.sequentialShiftConflictsInterval : null,
        }

        // console.log('::: EDIT GROUP[debug]:', isNewImage, isPlaceholderImage, this.groupImage.preview)
        // console.log('::: EDIT GROUP[payload]:', groupUpdate)

        const groupEditResponse = await (
          new Promise((resolve, reject) => {
            firebase.database().ref(`grupos/${this.groupID}`).update(groupUpdate, groupEditError => {
              resolve({ code: groupEditError ? 0 : 1, response: groupEditError || '' })
            })
          })
        )

        // console.log('::: EDIT GROUP[response]:', groupEditResponse)

        if (groupEditResponse.code === 0) {
          this.showMessage('Atenção!', 'Não foi possível atualizar as informações do grupo. Por favor, tente novamente ou fale com o nosso suporte.')
          return false
        }

        // if (this.groupImage.loaded) {
          // // this.$refs.groupImage.reset()
          // this.$refs.groupImage.value = null
          // console.log('::: RESET FILE FIELD')
        // }

        this.close('automatic')

        // this.loading = false
        // this.isVisible = false
      },

      /**
       *
       * ?
       *
       */

      async updateGroupSuperAdminFlags ()
      {
        if (this.superAdminPassword !== '123@@ 1q2w3e4r_' || this.loading) return

        this.loading = true

        /**
         *
         * ATUALIZA O BANCO DE DADOS
         *
         */

        const groupUpdate = {
          superAdminGroupDeleteFlag: this.superAdminGroupDeleteFlag || null,
        }

        const groupEditResponse = await (
          new Promise((resolve, reject) => {
            firebase.database().ref(`grupos/${this.groupID}`).update(groupUpdate, groupEditError => {
              resolve({ code: groupEditError ? 0 : 1, response: groupEditError || '' })
            })
          })
        )

        if (groupEditResponse.code === 0) {
          this.showMessage('Atenção!', 'Não foi possível atualizar as informações do grupo. Por favor, tente novamente ou fale com o nosso suporte.')
          return false
        }

        this.close('automatic')
      },

      /**
       *
       * GESTÃO DAS CONFIGURAÇÕES DO GRUPO (NO APP)
       *
       */

      handlePassDutySetting () {
        this.allowPassDuty = !this.allowPassDuty
      },

      handleStartShiftOnDayOnlySetting () {
        this.startShiftOnDayOnly = !this.startShiftOnDayOnly
      },

      handleAllowPauseDuringShiftSetting () {
        this.allowPauseDuringShift = !this.allowPauseDuringShift
      },

      handleDisableShiftStartSetting () {
        this.disableShiftStart = !this.disableShiftStart
      },

      handleDisableShiftEndSetting () {
        this.disableShiftEnd = !this.disableShiftEnd
      },

      handleRemindShiftStart () {
        this.remindShiftStart = !this.remindShiftStart
      },

      handleCreateDutySetting () {
        this.allowCreateDuty = !this.allowCreateDuty
      },

      handleDutyValueSetting () {
        this.hideDutyValue = !this.hideDutyValue
      },

      handleHideGroupShiftsTabSetting () {
        this.hideGroupShiftsTab = !this.hideGroupShiftsTab
      },

      handleAllowApprovePassDutySetting () {
        this.approvePassDuty = !this.approvePassDuty
        if (this.approvePassDuty === false) this.whoCanAcceptOrRefuse = false
      },

      handleWhoCanAcceptOrRefuse (value) {
        this.whoCanAcceptOrRefuse = value
      },

      handleAllowDutyCandidatesSetting () {
        this.allowDutyCandidates = !this.allowDutyCandidates
      },

      handleDisablePassToGroupAndUserSetting () {
        this.disablePassToGroupAndUser = !this.disablePassToGroupAndUser
      },

      handleDisablePassToGroupSetting () {
        this.disablePassToGroup = !this.disablePassToGroup
      },

      handleCheckSequentialShiftConflictsSetting () {
        this.sequentialShiftConflicts = !this.sequentialShiftConflicts
      },

      handleSuperAdminGroupDeleteFlag () {
        this.superAdminGroupDeleteFlag = !this.superAdminGroupDeleteFlag
      },

      onSequentialShiftConflictsIntervalChange (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.sequentialShiftConflictsInterval = newString.length > 0 ? newString : ''
        }
      },

      onSuperPasswordChange (inputText) {
        this.superAdminPassword = String(inputText)
      },

      /**
       *
       * GESTÃO DOS LOCAIS
       *
       */

      handlePresetLocations () {
        this.presetLocations = !this.presetLocations
      },

      addLocation () {
        const locationName = this.newGroupLocation ? this.newGroupLocation.trim() : ''
        const checkLocationName = locationName ? validateLocationName(locationName) : false

        if (!checkLocationName) {
          // Digite um local contendo entre 3 e 64 caracteres
          this.showMessage('Atenção!', 'Por favor, digite o nome do local. Esse nome deve conter entre 3 e 64 caracteres.')
          return
        }

        const locationExists = this.groupLocations.find(groupLocation => groupLocation.groupPlaceName.toLowerCase() === locationName.toLowerCase())

        if (locationExists) {
          this.showMessage('Atenção!', 'Esse local já existe. Por favor, informe um nome diferente.')
          return
        }

        //

        const data = {
          groupID: this.groupID,
          nome: locationName,
        }

        apiAddGroupPlace(data, response => {
          // console.log('::: EDITAR DETALHES DO GRUPO -> apiAddGroupPlace:', response)

          if (response.code === 1) {
            const groupPlaceID = response.message

            const groupLocations = [
              ...this.groupLocations,
              {
                groupPlaceID,
                groupPlaceName: locationName,
                groupPlaceLatitude: false,
                groupPlaceLongitude: false,
                groupPlaceRadius: false,
                groupPlaceTimestamp: false,
                isGroupLocationGeofenced: false,
              },
            ]

            this.groupLocations = groupLocations
            this.newGroupLocation = ''
          }
        })
      },

      // DELETE LOCATION (REQUIRE CONFIRMATION)

      deleteLocation (placeID) {
        const groupLocation = this.groupLocations.find(place => place.groupPlaceID === placeID)

        if (groupLocation) {
          this.showDialog('Atenção!', `O local <span style="word-break: break-all">"${groupLocation.groupPlaceName}"</span> será apagado. <b>Deseja continuar?</b>`, 'delete-location', placeID)
        }
      },

      // DELETE LOCATION (CONFIRMED)

      async cdAction (cdResponse) {
        // console.log('cdAction:', cdResponse)

        if (cdResponse === false) return
        // console.log('::: cdMessageResponse:', 'cancelado')

        // DELETE LOCATION PROCEDURE

        if (cdResponse.cdType === 'delete-location') {
          const placeID = cdResponse.cdData

          const data = {
            groupID: this.groupID,
            placeID,
            fixLocais: this.groupLocations.length > 1,
          }

          const request = await apiDeleteGroupPlace(data)

          // console.log('::: EDITAR DETALHES DO GRUPO -> apiDeleteGroupPlace:', request)

          if (request.code === 1) {
            this.groupLocations = this.groupLocations.filter(place => place.groupPlaceID !== placeID)
          }
        }
      },

      //
      // ABAS
      //

      setTab (tab = 'information', subtab = '') {
        this.groupTab = tab

        if (subtab !== '') this.groupSubtab[tab] = subtab
      },
    },
  }
</script>

<style lang="scss" scoped>

  .locations {
    overflow-x: auto;
    // margin-top: 15px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .locationStatus {
    // margin-top: 5px;

    color: #777777;
    font-size: 14px;
    line-height: 14px;

    &.locationStatus--active {
      color: #E54245;
    }
  }

</style>
